/* Playably Live Trigger Board — scroll reveal (vanilla JS). Load once. */
(function () {
  var SEL = '.cn-art .cn-eyebrow, .cn-art h1.cn-h1, .cn-art section h2.cn-h2, .cn-art .tb-sub, .cn-art .tb-sum-item, .cn-art .tb-feat-main, .cn-art .tb-feat-side, .cn-art .tb-card, .cn-art .tb-table, .cn-art .tb-table-note, .cn-art .tb-cta-inner';
  function reduce() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function tag() {
    var els = document.querySelectorAll(SEL); if (!els.length) return;
    var vh = window.innerHeight || 800; var counts = new Map();
    els.forEach(function (el) {
      if (el.__rv) return; el.__rv = true; el.classList.add('pa-rv');
      var r = el.getBoundingClientRect();
      if (reduce() || (r.top < vh * 0.92 && r.bottom > 0)) { el.classList.add('pa-rv-in'); return; }
      var p = el.parentElement, idx = counts.get(p) || 0;
      if (idx > 0) el.style.transitionDelay = Math.min(idx * 70, 420) + 'ms';
      counts.set(p, idx + 1);
    });
  }
  function check() {
    var vh = window.innerHeight || 800;
    document.querySelectorAll('.cn-art .pa-rv:not(.pa-rv-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.86) el.classList.add('pa-rv-in');
    });
  }
  function start() {
    if (window.__paTbRv) return; window.__paTbRv = true;
    if (!document.getElementById('pa-rv-style')) {
      var st = document.createElement('style'); st.id = 'pa-rv-style';
      st.textContent = '.cn-art .pa-rv{opacity:0;transform:translateY(28px);transition:opacity .7s cubic-bezier(.22,1,.36,1),transform .7s cubic-bezier(.22,1,.36,1)}.cn-art .pa-rv.pa-rv-in{opacity:1;transform:none}@media (prefers-reduced-motion: reduce){.cn-art .pa-rv{opacity:1!important;transform:none!important;transition:none!important}}';
      document.head.appendChild(st);
    }
    var ticking = false;
    function onScroll(){ if(ticking) return; ticking=true; requestAnimationFrame(function(){ ticking=false; check(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    var last = 0;
    (function loop(ts){ if(!last||ts-last>120){last=ts;tag();check();} if(document.querySelector('.cn-art .pa-rv:not(.pa-rv-in)')||!document.querySelector('.cn-art')) requestAnimationFrame(loop); })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();

/* Playably — live board category filter (Sports / Weather / Cultural / All) */
(function () {
  function initFilters(scope) {
    var bar = scope.querySelector('.tb-filters');
    var grid = scope.querySelector('.tb-grid');
    if (!bar || !grid || bar.__paf) return;
    bar.__paf = true;
    var btns = bar.querySelectorAll('.filter');
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('.filter');
      if (!b) return;
      for (var i = 0; i < btns.length; i++) btns[i].classList.remove('active');
      b.classList.add('active');
      var f = (b.textContent || '').trim().toLowerCase();
      var cards = grid.querySelectorAll('.tb-card');
      for (var j = 0; j < cards.length; j++) {
        var c = cards[j];
        if (c.classList.contains('add')) { c.style.display = (f === 'all') ? '' : 'none'; continue; }
        c.style.display = (f === 'all' || c.classList.contains(f)) ? '' : 'none';
      }
    });
  }
  function run() {
    var boards = document.querySelectorAll('.tb-live');
    for (var i = 0; i < boards.length; i++) initFilters(boards[i]);
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
